module.exports = __webpack_public_path__ + "./images/f6d1082a3c0e342669334c2de89f1e47.webp";